import type { PostHogConfig } from 'posthog-js';

export const createPostHogOptions = ({
  apiHost,
  development,
}: {
  apiHost: string;
  development: boolean;
}): Partial<PostHogConfig> => ({
  api_host: apiHost,
  defaults: '2025-11-30',
  autocapture: !development,
  session_recording: { recordBody: false, recordHeaders: false },
  loaded: (posthog) => {
    if (window.location.hostname === 'localhost') {
      posthog.opt_out_capturing();
    }
  },
});
